module.exports = __webpack_public_path__ + "static/media/information_icon.eeb08d13.png";